import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  row: {
    marginBottom: 140
  }
}))

export {
  useStyles
}